module.exports = __webpack_public_path__ + "static/media/85 - Muddy Monk - En Lea.d1c5329b.mp3";